import $ from 'jquery';

import ThemeUtils from '../utils/ThemeUtils';

export default class StaticPassword {
  constructor(section) {
    this.$el = $(section.el);
    
    this.events = [
      $('.password-entry', this.$el).on('click.password', () => this.togglePasswordForm()),
      $('.password-embedded-newsletter-form', this.$el).on('submit.password', () => this.toggleNewsletterSuccess()),
      $(window).on('load resize.password', this.themeUtils.debounce(this.setContentHeight, 100)),
    ];
    
    this.toggle = $('.password-entry', this.$el);
    this.subscribeWrapper = $('.password-subscribe-wrapper', this.$el);
    this.passwordWrapper = $('.password-form-wrapper', this.$el);
    this.newsletterInput = '.newsletter-input';
    this.emailRegEx = new RegExp(/^((?!\.)[a-z0-9._%+-]+(?!\.)\w)@[a-z0-9-\.]+\.[a-z.]{2,5}(?!\.)\w$/i);

    this.themeUtils = ThemeUtils;

    if ($('[data-password-form-inner]').hasClass('has-errors')) {
      this.togglePasswordForm();
    }
  }

  toggleNewsletterSuccess(event) {
    if (this.emailRegEx.test($(this.newsletterInput).val())) {
      $('.password-embedded-newsletter-form').addClass('hidden');
      $('.form-success.hidden').removeClass('hidden');
    } else {
      event.preventDefault();
    }
  }

  togglePasswordForm() {
    this.passwordWrapper.add(this.subscribeWrapper).toggleClass('visible');

    if (this.passwordWrapper.hasClass('visible')) {
      this.toggle.text(this.toggle.data('cancel'));
    } else {
      this.toggle.text(this.toggle.data('enter-password'));
    }
  }

  setContentHeight() {
    const footer = $('.footer-wrapper', this.$el);
    const windowHeight = $(window).height();
    const headerHeight = $('.main-header-wrapper', this.$el).outerHeight(true);
    const footerHeight = footer.outerHeight(true);
    const contentHeight = $('.main-content', this.$el).outerHeight(true);

    if (windowHeight > (headerHeight + contentHeight + footerHeight)) {
      footer.css({ position: 'fixed' });
    } else {
      footer.css({ position: 'relative' });
    }
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.password'));
  }
}
